import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IconName } from '@yupma/ui-kit';
import { OrganisationDocument } from 'server-model';
import { RouteLinkGenerator, RouteName } from 'src/app/routing-path';
import { IAMService, OrganisationDataService, UIService } from 'src/app/services/services.module';
import { environment } from 'src/environments/environment';

interface SidebarItemConfig {
  key: string;
  label: string;
  icon: string;
  activeIcon: string;
}


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  @Input() organisationDocument: OrganisationDocument | null = null;
  iconNames = IconName;
  routeNames = RouteName;
  environment = environment;
  sidebarItems: any;

  sidebarConfig: SidebarItemConfig[] = [
    { key: 'home', label: 'Home', icon: this.iconNames.HOME, activeIcon: this.iconNames.HOME_FILLED },
    // { key: 'search', label: 'Search', icon: this.iconNames.SEARCH, activeIcon: this.iconNames.SEARCH_FILLED },
    { key: 'search', label: 'Search', icon: this.iconNames.SEARCH, activeIcon: this.iconNames.SEARCH },
    { key: 'tasks', label: 'Tasks', icon: this.iconNames.CLIPBOARD_CHECK, activeIcon: this.iconNames.CLIPBOARD_CHECK_FILLED },
    { key: 'contacts', label: 'Contacts', icon: this.iconNames.USERS, activeIcon: this.iconNames.USERS_FILLED },
    // { key: 'companies', label: 'Companies', icon: this.iconNames.BUILDINGS, activeIcon: this.iconNames.BUILDINGS_FILLED },
    // { key: 'deals', label: 'Deals', icon: this.iconNames.DEAL, activeIcon: this.iconNames.DEAL_FILLED },
    // { key: 'products', label: 'Products', icon: this.iconNames.BOX, activeIcon: this.iconNames.BOX_FILLED },
    // { key: 'broadcasts', label: 'Broadcasts', icon: this.iconNames.MEGAPHONE, activeIcon: this.iconNames.MEGAPHONE_FILLED },
    // { key: 'calls', label: 'Calls', icon: this.iconNames.PHONE, activeIcon: this.iconNames.PHONE_FILLED },
    // { key: 'reports', label: 'Reports', icon: this.iconNames.CHART, activeIcon: this.iconNames.CHART_FILLED },
    // { key: 'automations', label: 'Automations', icon: this.iconNames.BOT, activeIcon: this.iconNames.BOT_FILLED },
    // { key: 'marketplace', label: 'Marketplace', icon: this.iconNames.SHOP, activeIcon: this.iconNames.SHOP_FILLED },
    { key: 'help', label: 'Help', icon: this.iconNames.HELP, activeIcon: this.iconNames.HELP_FILLED },
    { key: 'settings', label: 'Settings', icon: this.iconNames.SETTINGS, activeIcon: this.iconNames.SETTINGS_FILLED },
  ];


  constructor(
    private router: Router,
    private iamService: IAMService,
    private uiService: UIService,
    private organisationDataService: OrganisationDataService,
  ) { }

  ngOnInit() {
    this.init()
  }

  private async init() {
    const organisationId = this.iamService.getOrganisationId();
    const routeGenerators = this.getRouteGenerators();
    this.sidebarItems = this.sidebarConfig.map(item => {
      const routeGenerator = routeGenerators[`${item.key}`];
      const route = routeGenerator ? routeGenerator(organisationId) : '';
      return {
        route,
        label: item.label,
        icon: item.icon,
        activeIcon: item.activeIcon,
      };
    });

    // await this.getOrganisation();
  }

  private async getOrganisation() {
    try {
      const organisationId = this.iamService.getOrganisationId();
      this.organisationDocument = (await this.organisationDataService.getOrganisation(organisationId)).data;
    } catch (error) {
      console.log(error);
    }
  }

  private getRouteGenerators(): any {
    return {
      home: RouteLinkGenerator.home,
      search: RouteLinkGenerator.search,
      tasks: RouteLinkGenerator.tasks,
      contacts: RouteLinkGenerator.contacts,
      companies: RouteLinkGenerator.companies,
      deals: RouteLinkGenerator.deals,
      products: RouteLinkGenerator.products,
      broadcasts: RouteLinkGenerator.broadcasts,
      calls: RouteLinkGenerator.calls,
      reports: RouteLinkGenerator.reports,
      automations: RouteLinkGenerator.automations,
      marketplace: RouteLinkGenerator.marketplace,
      help: RouteLinkGenerator.help,
      settings: RouteLinkGenerator.settings,
    };
  }

  isActiveRoute(route: string): boolean {
    return this.router.url.includes(`/${route}`);
  }
}
